import React from 'react'

import { ResponsiveImageContainer, ResponsiveImage } from '@vp/swan'

import PurcsProductPreview from './PurcsProductPreview'
import { useProject } from '../root/contexts/ProjectContext'

const Preview: React.FC = () => {
  const { work } = useProject()

  if (!work?.workId) return <></>

  // Quick fix to get previews working for YSD. Long-term do we
  // want to continue using this contract field or another mechanism?
  if (work.design?.metadata?.previewUrl) {
    return (
      <ResponsiveImageContainer aspectRatio={1}>
        <ResponsiveImage src={work.design.metadata.previewUrl} alt={'preview'} />
      </ResponsiveImageContainer>
    )
  }

  return <PurcsProductPreview />
}

export default Preview
